<div [class.hidden]="!show">
  <div class="loader-overlay">
    <div *ngIf="show" class="loader">..............................</div>
  </div>
</div>
